var $carousel = $('.js-industries-carousel'),
  $practicesBelt = $('.js-practices-carousel-belt'),
  $carouselBelt,
  $prevBtn,
  $nextBtn,
  $industryTab;

  if (!$carousel.length) return;

  $carouselBelt = $carousel.find('.js-industries-carousel-belt')
  $prevBtn = $('.js-industries-carousel-arrow-prev')
  $nextBtn = $('.js-industries-carousel-arrow-next')
  $industryTab = $('.tabs-nav__item').first();

  setTimeout(function() {
    $carouselBelt.not('.slick-initialized').slick({
      slide: '.js-industries-carousel-slide',
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick'
        }
      ]
    })
  }, 2000);

  $prevBtn.click(function() {
    $carouselBelt.slick('slickPrev')
  })

  $nextBtn.click(function() {
    $carouselBelt.slick('slickNext')
  })

  $industryTab.click(function() {
    // $practicesBelt.slick('destroy');
    $carouselBelt.slick('init');
  })

  $(window).on('resize', function() {
    $carouselBelt.slick('resize');
  })